export enum DateFilters {
  TODAY = 0,
  TOMORROW = 1,
  ACTIVES = 2,
  ACTIVES_AND_FUTURES = 3,
  TOMORROW_ONLY = 4,
  WEEK = 7,

  MONTH = 30,
  THIRTYDAYS = 31,
  THREE_MONTHS = 90,
  TWELVE_MONTHS = 365,

  CUSTOM = 100,
  RECORDS_LIM_200 = 200,
  RECORDS_LIM_500 = 500,
  LAST_CLOSED_YEAR = 101,
  FIRS_SEMESTER = 102,
  SECOND_SEMESTER = 103,
  RECORDS_LIM_1000 = 1000,

  // Past
  YESTERDAY = -1,
  LASTWEEK = -7,
  LASTMONTH = -30,
  LAST_CLOSED_QUARTER = -90
}
